
import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { Proposal } from '../models/proposal.model';
import { ProposalAction, ProposalStatus } from '../constants/buy-basic-data';
import { ProposalModif } from '../models/proposal-modif.model';
import { AppUrl } from '../../common/constants/app-urls';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

@Injectable({
  providedIn: 'root',
})
export class BuyService {
    //loggedIn = false;
  constructor(private http: HttpClient) {}

  addNewProposal(proposal: Proposal): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.buyProposals+"/new", 
        proposal, 
        httpOptions );
  }
  
  updateProposal(proposal: Proposal): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.buyProposals+"/update", 
      proposal,
      httpOptions );  
  }

  updateProposalStatus(proposalId: number, status: ProposalStatus): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.buyProposals+"/"+proposalId+"/update-status", 
      {data: status},
      httpOptions ); 
  }

  executeProposalAction(action: ProposalAction, proposal: Proposal | ProposalModif): Observable<any>{ 
        
    return this.http.post<any>(
      AppUrl.buyProposals+"/action/"+action, 
      proposal,
      httpOptions );  
  }

  rescheduleProposal(proposalId: number, rescDate: string): Observable<any>{ 
      
    return this.http.post<any>(
      AppUrl.buyProposals+"/"+proposalId+"/reschedule", 
      {dateTime: rescDate},
      httpOptions );  
  }

  createNewOffer(carId: string, amount: number): Observable<any>{ 
    return this.http.post<any>(
        AppUrl.carDetails+"/"+carId+"/offer/new", 
        {amount: amount}, 
        httpOptions );
  }
  
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
